// Quick View Alpine component — auto-bundled via main.js
// Per-page visibility config injected by quick_view_variant_1.jinja into #quick-view-config
;(function () {
const _qvConfigEl = document.getElementById('quick-view-config');
const _qvConfig = _qvConfigEl
    ? JSON.parse(_qvConfigEl.textContent)
    : { visibility: {}, badgePosition: 'top-right' };

window.qvFromEl = function(id) {
    const el = document.getElementById('qv-data-' + id);
    if (!el) return {};
    const d = el.dataset;
    const text = (key) => el.querySelector(`[data-qv="${key}"]`)?.textContent.trim() || '';
    return {
        href: d.href || '',
        image_src: d.imageSrc || '',
        name: text('name'),
        price: text('price'),
        maker: text('maker'),
        maker_label: text('maker-label') || 'Maker',
        sku: text('sku'),
        category: text('category'),
        reference: text('reference'),
        description: text('description'),
        actions: { add_to_cart: d.addToCart === '1' ? 1 : 0 },
        badges: Array.from(el.querySelectorAll('[data-qv="badge"]')).map(b => ({
            text: b.textContent.trim(),
            background_color: b.dataset.bg,
            text_color: b.dataset.fg
        })),
        available_items: 'availableCount' in d ? { count: +d.availableCount, url: d.availableUrl || '' } : {},
        sold_items: 'soldCount' in d ? { count: +d.soldCount, url: d.soldUrl || '' } : {}
    };
};

if (typeof window.quickViewModal === 'undefined') {
    window.quickViewModal = function () {
        return {
            open: false,
            product: null,
            visibility: _qvConfig.visibility || {},
            badgePosition: _qvConfig.badgePosition || 'top-right',

            init() {
                if (performance.navigation.type === 2 || window.history.state !== null) {
                    this.open = false;
                }
                this.$watch('open', (value) => {
                    document.body.style.overflow = value ? 'hidden' : '';
                });
            },

            openQuickView(data) {
                this.product = data;
                this.open = true;
            },

            closeQuickView() {
                this.open = false;
                setTimeout(() => { this.product = null; }, 300);
            },

            hasValidPrice(price) {
                if (!price) return false;
                const priceStr = String(price).trim();
                return priceStr && priceStr !== '0' && priceStr !== '0.00';
            },

            renderTitle(title) {
                if (!title) return '';
                if (typeof title === 'object' && title.en) return title.en;
                return String(title);
            },

            renderText(text) {
                if (!text) return '';
                if (typeof text === 'object' && text.en) return text.en;
                if (typeof text === 'object') return '';
                return String(text);
            },

            decodeBase64(str) {
                if (!str || typeof str !== 'string') return '';
                try {
                    return decodeURIComponent(escape(atob(str)));
                } catch (e) {
                    return str;
                }
            },

            stripHtml(html) {
                if (!html) return '';
                // Preserve <br> as newlines before stripping tags
                const withBreaks = html.replace(/<br\b[^>]*\/?>/gi, '\n');
                const tmp = document.createElement('div');
                tmp.innerHTML = withBreaks;
                return (tmp.textContent || tmp.innerText || '').trim();
            },

            getDescription() {
                if (!this.product || !this.product.description) return '';
                const desc = this.product.description;
                let rawDesc = '';
                if (typeof desc === 'string') {
                    rawDesc = desc;
                } else if (typeof desc === 'object' && desc !== null) {
                    rawDesc = desc.en || '';
                }
                if (!rawDesc) return '';
                let plainText = this.stripHtml(this.decodeBase64(rawDesc)).trim();
                if (plainText.length > 400) plainText = plainText.substring(0, 400) + '...';
                return plainText;
            },

            hasDescription() {
                return !!this.getDescription();
            },

            hasValidText(text) {
                if (!text) return false;
                if (typeof text === 'object' && text.en) return !!text.en.trim();
                if (typeof text === 'object') return false;
                return !!String(text).trim();
            }
        };
    };
}
})();
